'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _immutable = require('immutable');

var _reduxActions = require('redux-actions');

var _ActionTypes = require('../constants/ActionTypes');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _actionTypes = require('../../widget-data/constants/actionTypes');

var _hasGivenConsentToProcess = require('../../widget-data/operators/hasGivenConsentToProcess');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = (0, _immutable.Map)({
  hasVisitorGivenConsentToProcess: false
});

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.GET_WIDGET_DATA_SUCCEEDED, function (state, action) {
  var widgetData = action.payload;

  return state.set('hasVisitorGivenConsentToProcess', (0, _hasGivenConsentToProcess.hasGivenConsentToProcess)(widgetData));
}), _defineProperty(_handleActions, _actionTypes.REFRESH_WIDGET_DATA, function (state, action) {
  var widgetData = action.payload;

  return state.set('hasVisitorGivenConsentToProcess', (0, _hasGivenConsentToProcess.hasGivenConsentToProcess)(widgetData));
}), _defineProperty(_handleActions, _ActionTypes.CONSENT_TO_PROCESS_SUCCEEDED, function (state) {
  return state.set('hasVisitorGivenConsentToProcess', true);
}), _handleActions), initialState);
module.exports = exports['default'];